import { merge } from 'lodash';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import { Card, Typography, Box, Popover } from '@mui/material';
import { connect } from 'react-redux';
import { fNumber } from '../../../utils/formatNumber';
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------

function AppTypes(props) {
  const [typeYaxis, setTypeYaxis] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);



  useEffect(() => {
    const maxY = Math.max(...props.patients.gms_type);
    setTypeYaxis(maxY + (maxY * 0.2));
  }, [props.patients.gms_type]);

  // Add tooltip content for each category
  const tooltipContent = {
    'Medical Card Patients': 'This includes patients on the General Medical Scheme, Doctor Visit Scheme and EU visitors.',
    'Private Patients': 'This includes patients with health insurance and patients that have neither health insurance nor a medical card.',
    'APMS': 'Alternative Provider Medical Services - Flexible contract for a wide range of providers.',
    // Add more categories and their descriptions as needed
  };

  const handleClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setActiveIndex(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveIndex(null);
  };

  const open = Boolean(anchorEl);


  const CHART_DATATypes = [
    {
      data: props.patients.gms_type,
    }
  ];

  const chartOptions_TypesBar = merge(BaseOptionChart(), {
    tooltip: {
      enabled: false
    },
    grid: {
      borderColor: "transparent",
      row: {
        colors: ["transparent"],
        opacity: 0.5,
      },
    },
    colors: props.patients.gms_colors,
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          position: 'top'
        },
        columnWidth: '50%',  // Reduce from 60% to 40% to create more space
        distributed: true,
        endingShape: 'rounded',  // Optional: adds rounded corners to bars
        borderRadius: 10,
      },
    },
    legend: {
      show: false
    },
    dataLabels: {
      formatter: (val) => fNumber(val),
      enabled: true,
      style: {
        colors: ['#1F4E79']
      },
      offsetY: -20
    },
    xaxis: {
      show: false,
      categories: props.patients.gms_categories,
      labels: {
        show: false  // This will hide the x-axis labels
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      show: false
    },
    stroke: {
      show: false
    }
  });

  return (
    <Card sx={{ boxShadow: 'none', mt: 4 }}>
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={CHART_DATATypes}
          options={chartOptions_TypesBar}
          height={280}
        />
      </Box>

      {/* Bar Labels with Icons (Aligned Like First Image) */}
      <Box sx={{ paddingX: '20px', display: 'flex', justifyContent: 'center', gap: '20px', mt: -2 }}>
        {props.patients.gms_categories.map((label, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', }}>
              <Typography variant="body2" fontWeight="bold" color="#205c7d">
                {label}
              </Typography>
              <Box
                onClick={(e) => handleClick(e, index)}
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  backgroundColor: '#d3f0f3',
                  border: '2px solid #205c7d',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 'bold',
                  color: '#a02961',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#bce7eb',
                  },
                }}
              >
                i
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPopover-paper': {
            padding: '8px 12px',
            maxWidth: 220,
            backgroundColor: '#FFFFFF',
            border: '1px solid #22577A',
          },
        }}
      >
        <Typography variant="body2" color="#22577A">
          {activeIndex !== null && tooltipContent[props.patients.gms_categories[activeIndex]]}
        </Typography>
      </Popover>
    </Card>

  );
}

const mapState = state => ({
  patients: state.overview.patients
});

const mapDispatch = ({
  overview: { loadData }
}) => ({
  loadData: () => loadData()
});

export default connect(mapState, mapDispatch)(AppTypes);
